import {
  raFormLayoutLanguageItalian,
  raLanguageItalian,
  raRelationshipsLanguageItalian,
  ordLanguageItalian,
} from '@ragu-components/ord-providers';

import { callflowLanguageItalian } from './callflows/callflowLanguageItalian';
import { resourcesLanguageItalian } from './resources';

import type { TranslationMessages } from './translationMessages';

export const languageItalian: TranslationMessages = {
  ...raLanguageItalian,
  ...callflowLanguageItalian,
  ...raFormLayoutLanguageItalian,
  ...raRelationshipsLanguageItalian,
  ...ordLanguageItalian,
  ...resourcesLanguageItalian,
  ord: {
    ...(ordLanguageItalian.ord ?? {}),
    permissions: {
      ...(ordLanguageItalian.ord?.permissions ?? {}),
      ap_configurations: 'Configurazioni di Autoprovisioning',
      ap_groups: 'Gruppi di Autoprovisioning',
      ap_authentication: 'Autenticazione di Autoprovisioning',
      ap_settings: 'Impostazioni di Autoprovisioning',
      ap_templates: 'Template di Autoprovisioning',
      assigned_carriers: 'Trunk SIP del Dominio',
      assigned_inbound_e164s: 'E164 in Entrata del Dominio',
      assigned_lcrs: 'LCR del Dominio',
      assigned_sip_profiles: 'Profili SIP del Dominio',
      calls: 'Chiamate',
      encryption_configurations: 'Chiavi di Crittografia dello Storage',
      presence: 'Presenza',
      storage_configurations: 'Configurazioni di Storage Esterni',
    },
    validation: {
      ...(ordLanguageItalian.ord?.validation ?? {}),
      pattern: 'Formato non valido',
    },
  },
};
